module.exports = __webpack_public_path__ + "static/media/lat_light_header@2x.028c3051.png";